import * as SSR from "../../api/hooks/lib/ssr.js"
import { addMessages, init, getLocaleFromNavigator, locale } from "svelte-i18n"
import { get, writable } from "svelte/store"

import de from "./../locales/de.json"
import en from "./../locales/en.json"
import fr from "./../locales/fr.json"
import it from "./../locales/it.json"
import nl from "./../locales/nl.json"
import { location } from "./store"

addMessages("de", de)
addMessages("en", en)
addMessages("fr", fr)
addMessages("it", it)
addMessages("nl", nl)
export const fallbackLocale = "de"
export const locales = ["de", "en", "fr", "it", "nl"]
export const localesMap = {
    de: "Deutsch",
    en: "English",
    fr: "Français",
    it: "Italiano",
    nl: "Nederlands",
}
function getLocale(): string {
    const loc = get(location)
    // check if already starts with one of locales
    const found = loc.path.match(/^\/(de|en|fr|se|dk|nl|it)(\/|$)/)
    if (found) return found[1]
    return getLocaleFromNavigator() || fallbackLocale
}
export const navigatorLocale = getLocale()
export const initialLocale = navigatorLocale.replace(/\-.+$/, "")

init({
    fallbackLocale,
    initialLocale,
})

export function langField(field: any, _default?: any): any {
    if (field) {
        const prio = [initialLocale, ...locales]
        for (let i = 0; i < prio.length; i++) {
            if (field[prio[i]]) {
                return field[prio[i]]
            }
        }
    }
    return _default
}

function getCurrencyFormater(locale: string) {
    return (price: number, vatPercent = 0, quantity = 1) => {
        return SSR.formatPrice(price, vatPercent, quantity, locale, true) as string
    }
}

export const formatPriceCurrency = writable(getCurrencyFormater(navigatorLocale))

locale.subscribe((l) => {
    formatPriceCurrency.set(getCurrencyFormater(l))
})
